import React from 'react';
import PropTypes from 'prop-types';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import {
  LAUREL_LEFT_SRC,
  LAUREL_RIGHT_SRC,
  LAUREL_RIGHT_HOVER_SRC,
  LAUREL_LEFT_HOVER_SRC,
} from 'site-modules/shared/constants/top-rated/top-rated';

export function LaurelIcons({ maxWidth = '490px' }) {
  return (
    <div className="pos-a w-100 h-100 laurels" style={{ maxWidth }}>
      <img
        src={getStaticImageUrl(LAUREL_LEFT_SRC)}
        alt=""
        width={81}
        height={116}
        aria-hidden
        className="pos-a left-0 laurel"
      />
      <img
        src={getStaticImageUrl(LAUREL_LEFT_HOVER_SRC)}
        alt=""
        width={81}
        height={116}
        aria-hidden
        className="pos-a left-0 laurel-hover"
      />
      <img
        src={getStaticImageUrl(LAUREL_RIGHT_SRC)}
        alt=""
        width={81}
        height={116}
        aria-hidden
        className="pos-a right-0 laurel"
      />
      <img
        src={getStaticImageUrl(LAUREL_RIGHT_HOVER_SRC)}
        alt=""
        width={81}
        height={116}
        aria-hidden
        className="pos-a right-0 laurel-hover"
      />
    </div>
  );
}

LaurelIcons.propTypes = {
  maxWidth: PropTypes.string,
};
